export const TRADEIN = 'Trade-In'
export const CREDIT = 'Кредит'
export const STRAIGHT = 'Прямая'
export const CASH = 'Наличный'
export const CASHLESS = 'Безналичный'
export const LEASING = 'Лизинг'
